import React, { useState, useMemo, useEffect } from 'react';
import { useUserContext } from '../UserContext';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';
import RelatorioPacotesTab from '../components/relatorios/RelatorioPacotesTab';

const RelatoriosPage = () => {
    const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext();
    const { currentEntidade } = useEntidadeContext();

    const permittedTabs = useMemo(() => {
        return getPermittedInternalTabs('relatorios', currentUserRole);
    }, [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig]);

    const [activeTabKey, setActiveTabKey] = useState('');

    useEffect(() => {
        if (permittedTabs.length > 0 && !activeTabKey) {
            setActiveTabKey(permittedTabs[0].key);
        }
    }, [permittedTabs, activeTabKey]);

    return (
        <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                .relatorios-tab-btn {
                    padding: 12px 18px; border: none; background: none;
                    font-size: 13px; font-weight: 500; color: #6b7280;
                    border-bottom: 2px solid transparent; margin-bottom: -2px;
                    cursor: pointer; transition: all 0.15s; white-space: nowrap;
                    font-family: 'Inter', 'Segoe UI', sans-serif;
                }
                .relatorios-tab-btn:hover { color: #374151; background: #f9fafb; border-radius: 6px 6px 0 0; }
                .relatorios-tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; font-weight: 600; }
            `}</style>

            {/* ── CABEÇALHO ── */}
            <div style={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                padding: '20px 28px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <img
                        src={logoImage}
                        alt="Logo"
                        style={{ height: '44px', width: 'auto', opacity: 0.9 }}
                    />
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#fff' }}>
                            Relatórios Gerenciais
                        </h2>
                        <p style={{ margin: 0, fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>
                            {currentEntidade?.nome || 'Clínica'}
                        </p>
                    </div>
                </div>
                <div style={{
                    padding: '4px 12px', borderRadius: '999px',
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    fontSize: '12px', fontWeight: '600', color: '#fff',
                    border: '1px solid rgba(255,255,255,0.25)',
                }}>
                    {currentUserRole}
                </div>
            </div>

            {/* ── ABAS ── */}
            <div style={{ backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{
                    display: 'flex', borderBottom: '2px solid #e2e8f0',
                    padding: '0 24px', gap: '4px', flexWrap: 'wrap',
                }}>
                    {permittedTabs.length === 0 ? (
                        <div style={{ padding: '12px 0', fontSize: '13px', color: '#9ca3af' }}>
                            Nenhuma aba disponível para o seu perfil.
                        </div>
                    ) : (
                        permittedTabs.map(tabInfo => (
                            <button
                                key={tabInfo.key}
                                className={`relatorios-tab-btn ${activeTabKey === tabInfo.key ? 'active' : ''}`}
                                onClick={() => setActiveTabKey(tabInfo.key)}
                            >
                                {tabInfo.title}
                            </button>
                        ))
                    )}
                </div>
            </div>

            {/* ── CONTEÚDO ── */}
            <div style={{ padding: '24px 28px' }}>
                {permittedTabs.length === 0 ? (
                    <div style={{
                        textAlign: 'center', padding: '60px 24px',
                        backgroundColor: '#fff', borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                    }}>
                        <svg width="48" height="48" fill="none" stroke="#d1d5db" viewBox="0 0 24 24"
                            style={{ display: 'block', margin: '0 auto 16px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p style={{ margin: 0, fontSize: '14px', color: '#9ca3af' }}>
                            Você não tem permissão para visualizar relatórios.
                        </p>
                    </div>
                ) : (
                    permittedTabs.map(tabInfo => {
                        if (activeTabKey !== tabInfo.key) return null;

                        if (tabInfo.key === 'rel_pacote_servicos') return (
                            <RelatorioPacotesTab
                                key={tabInfo.key}
                                isActive={activeTabKey === tabInfo.key}
                            />
                        );

                        // Placeholder para abas futuras
                        return (
                            <div key={tabInfo.key} style={{
                                textAlign: 'center', padding: '60px 24px',
                                backgroundColor: '#fff', borderRadius: '12px',
                                border: '1px dashed #e5e7eb',
                            }}>
                                <svg width="40" height="40" fill="none" stroke="#d1d5db" viewBox="0 0 24 24"
                                    style={{ display: 'block', margin: '0 auto 12px' }}>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                </svg>
                                <p style={{ margin: 0, fontSize: '14px', color: '#9ca3af' }}>
                                    Relatório <strong>{tabInfo.title}</strong> em desenvolvimento.
                                </p>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default RelatoriosPage;
